export default {"src":"/_next/static/media/ppt.73bfd0bd.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};